import type { AdminUser } from '@/types/auth.types';
import logger from './logger';

const TOKEN_KEY = 'adminToken';
const USER_KEY = 'adminUser';

export const auth = {
  getToken(): string | null {
    const localToken = localStorage.getItem(TOKEN_KEY);
    const sessionToken = sessionStorage.getItem(TOKEN_KEY);
    const token = localToken || sessionToken;
    logger.log('Getting token - localStorage:', localToken ? 'Found' : 'Not found', 'sessionStorage:', sessionToken ? 'Found' : 'Not found');
    return token;
  },

  setToken(token: string, remember = true): void {
    logger.log('Setting token:', token, 'remember:', remember);
    if (remember) {
      localStorage.setItem(TOKEN_KEY, token);
      const saved = localStorage.getItem(TOKEN_KEY);
      logger.log('Token saved to localStorage. Verification:', saved === token ? 'SUCCESS' : 'FAILED');
    } else {
      sessionStorage.setItem(TOKEN_KEY, token);
      const saved = sessionStorage.getItem(TOKEN_KEY);
      logger.log('Token saved to sessionStorage. Verification:', saved === token ? 'SUCCESS' : 'FAILED');
    }
  },

  removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
  },

  getUserInfo(): AdminUser | null {
    const raw = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as AdminUser;
    } catch {
      return null;
    }
  },

  setUserInfo(user: AdminUser, remember = true): void {
    const data = JSON.stringify(user);
    if (remember) {
      localStorage.setItem(USER_KEY, data);
    } else {
      sessionStorage.setItem(USER_KEY, data);
    }
  },

  removeUserInfo(): void {
    localStorage.removeItem(USER_KEY);
    sessionStorage.removeItem(USER_KEY);
  },

  isAuthenticated(): boolean {
    const authenticated = !!this.getToken();
    logger.log('isAuthenticated check:', authenticated);
    return authenticated;
  },

  clear(): void {
    this.removeToken();
    this.removeUserInfo();
  },
};
